export function NoHitHistorianIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="24" cy="24" r="16" />
      <line x1="14" y1="14" x2="34" y2="34" />
      <line x1="34" y1="14" x2="14" y2="34" />
      <circle cx="24" cy="24" r="6" />
    </svg>
  );
}
